import type { EditorServiceModels } from '@editor/client-rest-api';
import getStore from '../store/store';

export default function getDefaultOptions(): EditorServiceModels.CritiqueTypeInfo[] {
    const store = getStore();
    const { defaultOptionsEditor } = store;

    return [...defaultOptionsEditor.values()].map(c => c.critiqueTypeInfo);
}

export function getDefaultUIOptions(): EditorServiceModels.CritiqueTypeInfo[] {
    const store = getStore();
    const { defaultOptionsUI } = store;

    return [...defaultOptionsUI.values()].map(c => c.critiqueTypeInfo);
}
